import React, { Component } from 'react';
import { Switch, Route, matchPath, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { SUBTABS, HISTORY_STEPS } from './ConstPaths';

import GatherInfoHistoryPastMethodEntry from './GatherInfoHistoryPastMethodEntry';
import GatherInfoHistoryPastMethodsReview from './GatherInfoHistoryPastMethodsReview';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  pastMethods: PropTypes.arrayOf(PropTypes.object), 
  onChangePastMethods: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  pastMethods: []
};

const steps = HISTORY_STEPS;
const BASE_URL = SUBTABS.HISTORY + "/";
const METHOD_STEPS = {
  ADD: 'add',
  EDIT: 'edit'
}
const pathForAdd = BASE_URL+ steps.PAST_METHODS + "/" + METHOD_STEPS.ADD;
const pathForEdit = BASE_URL+ steps.PAST_METHODS + "/" + METHOD_STEPS.EDIT;

//content sub-component with unique content for this page
class GatherInfoHistoryPastMethods extends Component {
  constructor(props){
    super(props);

    //manage the form values for each method as local state
    this.state = {
      methodName: "",
      methodNotes: "",
      methodNameError: "",
      pastMethods: this.props.pastMethods
    };
    
    this.onDoneWithMethod = this.onDoneWithMethod.bind(this);
    this.onAddMethod = this.onAddMethod.bind(this); //essential for props.history to work in the function
    this.onEditMethod = this.onEditMethod.bind(this);
    this.onDeleteMethod = this.onDeleteMethod.bind(this);
  }

  onAddMethod(){
    this.setState({methodName:""});
    this.setState({methodNotes:""});
    this.setState({methodNameError: ""});
    const curURL = new URL(window.location.href);

    this.props.history.push({
      pathname: pathForAdd,
      search: curURL.search
    });
    //this.props.history.push(pathForAdd);
  }

  //same as Add, except pass in the selected methodName
  onEditMethod(index){
    var methodToEdit = this.state.pastMethods[index];
    this.setState({methodName: methodToEdit.name}); 
    this.setState({methodNotes: methodToEdit.notes}); 
    const curURL = new URL(window.location.href);

    this.props.history.push({
      pathname: pathForEdit + "/" + index,
      search: curURL.search
    });
    //this.props.history.push(pathForEdit + "/" + index);
  }

  //handle changes in the child form
  handleChange(field) {
    return evt => {
      this.setState({ [field]: evt.target.value });
    }
  }
  
  validate(methodName){
    let errorMsg = '';
    let allOK = true;
    if(methodName === ''){
      errorMsg = 'Please enter a name for the past method';
      allOK = false;
    }
    this.setState({methodNameError: errorMsg});
    return allOK;
  }

  //add the info from the child form into the currentMethods
  //then go to the review page
  onDoneWithMethod(){
    const history = this.props.history;
    //https://stackoverflow.com/questions/45487779/how-to-get-params-in-parent-route-component
    const matchStep = matchPath(history.location.pathname, {
      path: "/gather-info/history/past-methods/:step",
    });
    const step = matchStep.params.step;
    const curURL = new URL(window.location.href);


    if(this.validate(this.state.methodName)){
      //replace if editing
      if(step === METHOD_STEPS.EDIT){
        const matchEdit = matchPath(this.props.history.location.pathname, {
          path: "/gather-info/history/past-methods/edit/:ix",
        });
        const ix = matchEdit.params.ix;
        const newPastMethods = this.state.pastMethods.slice(0);
        newPastMethods[ix].name = this.state.methodName;
        newPastMethods[ix].notes = this.state.methodNotes;
        this.setState({pastMethods: newPastMethods}, this.updateIt);
      }

      //concatenate if adding
      if(step === METHOD_STEPS.ADD){
        //add the new object to this.state.pastMethods, making sure to use setState
        //https://stackoverflow.com/questions/37435334/correct-way-to-push-into-state-array
        //
        //use the callback to update currentMethods in the parent component properly
        //https://stackoverflow.com/questions/38558200/react-setstate-not-updating-immediately
        const newPastMethod = {};
        newPastMethod.name = this.state.methodName;
        newPastMethod.notes = this.state.methodNotes;
        console.log("adding: " + JSON.stringify(newPastMethod));
        this.setState((prevState) => {
          return{
            pastMethods: prevState.pastMethods.concat(newPastMethod)
          };
        }, this.updateIt);
      }
      history.push({
        pathname: BASE_URL + steps.PAST_METHODS,
        search: curURL.search
      });
      // history.push(BASE_URL+ steps.PAST_METHODS);
    }
  }

  //https://stackoverflow.com/questions/43230622/reactjs-how-to-delete-item-from-list/43230714
  onDeleteMethod(ixToDelete){
    this.setState((prevState) => {
      return{
        pastMethods: prevState.pastMethods.filter(function(value, index, arr){
          return index !== ixToDelete;
        })
      };
    }, this.updateIt);
  }

  //Update the currentMethods in the parent component
  //Uses the callback supplied by parent
  updateIt = () => {
    this.props.onChangePastMethods(this.state.pastMethods)
  }
  
  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  componentDidUpdate(prevProps, prevState){
    //for values that are Arrays:
    if (_.isEqual(this.props.pastMethods, prevProps.pastMethods) === false){
      console.log("--incoming props: " + this.props.pastMethods + " differ from prev props: " + prevProps.pastMethods);
      this.setState({'pastMethods': this.props.pastMethods});
    };
  }

  render(){
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const saveFormData = this.props.saveFormData;
    const onContinue = this.props.onContinue;

    console.log("rendering GatherInfoHistoryPastMethods with pastMethods state: " + this.state.pastMethods);
    
    return(
      <>
      <Switch>
        <Route exact path={[pathForAdd, pathForEdit + "/:ix"]}>
          <GatherInfoHistoryPastMethodEntry
            firstName={firstName}
            pronouns={pronouns}
            methodName={this.state.methodName}
            onChangeMethodName={this.handleChange("methodName")}
            methodNameError={this.state.methodNameError}
            methodNotes={this.state.methodNotes}
            onChangeMethodNotes={this.handleChange("methodNotes")}
            onContinue={this.onDoneWithMethod}
          />
        </Route>
        <Route>
          <GatherInfoHistoryPastMethodsReview
            firstName={firstName} 
            pronouns={pronouns}
            pastMethods={this.state.pastMethods}
            onAddMethod={this.onAddMethod}
            onEditMethod={this.onEditMethod}
            onDeleteMethod={this.onDeleteMethod}
            savePastMethods={saveFormData}
            onContinue={onContinue}
          />
        </Route>
      </Switch>
      </>
    );
  }
}  

GatherInfoHistoryPastMethods.propTypes = propTypes;
GatherInfoHistoryPastMethods.defaultProps = defaultProps;

export default withRouter(GatherInfoHistoryPastMethods);